import React from "react";
import Report from "../report/report";
import {Utils} from "../../../helpers/utils";
import {IPaginationStore} from "../../../common/stores/paginationStore";
import {storesContext} from "../../../common/stores/stores";
import i18n from "../../../i18n/i18n";
import {ValidatedValue} from "../../../helpers/validatedValue";
import {RelationType} from "../../../transportation/models/relation";
import {CargoType} from "../../../transportation/models/cargo";
import {OrderStatusEnum} from "../../../transportation/models/order";
import DateTimePicker from "../../../common/components/shared/dateTimePicker/dateTimePicker";
import {FerryDropDownModel} from "../../../dictionaries/models/ferry";
import {ShipownerModel} from "../../../dictionaries/models/shipowners";
import {ShipownerService} from "../../../dictionaries/services/shipownerService";
import {FerryService} from "../../../dictionaries/services/ferryService";
import {DropDownModel} from "../../../common/models/dropDown";
import {DropDownUtils} from "../../../helpers/dropDownUtils";
import DropDown from "../../../common/components/shared/dropDown/dropDown";
import MultiSelectDropDown from "../../../common/components/shared/multiSelectDropDown/multiSelectDropDown";
import Checkbox from "../../../common/components/shared/checkbox/checkbox";
import Validator from "../../../helpers/validator";
import RelationTypeDropdownItems from "../../../helpers/relationTypeDropdownItems";
import CargoTypeDropdownItems from "../../../helpers/cargoTypeDropdownItems";
import OrderStatusDropdownItems from "../../../helpers/orderStatusDropdownItems";
import {ListOfShipmentsFilters, ListOfShipmentsModel, ListOfShipmentsSummaryModel} from "../../models/listOfShipments";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {DateUtils} from "../../../helpers/dateUtils";
import {ListOfShipmentsService} from "../../services/listOfShipmentsService";
import {Api} from "../../../helpers/api";
import Loader from "../../../common/components/shared/loader/loader";

interface ListOfShipmentsState{
    selectedArrivalFerryFrom: ValidatedValue<Date | null>;
    selectedArrivalFerryTo: ValidatedValue<Date | null>;
    selectedDepartureFerryFrom: ValidatedValue<Date | null>;
    selectedDepartureFerryTo: ValidatedValue<Date | null>;
    selectedRelationType: ValidatedValue<RelationType[] | []>;
    selectedCargoType: ValidatedValue<CargoType[] | []>;
    selectedOrderStatus: ValidatedValue<OrderStatusEnum[] | []>;
    selectedShipowner: ValidatedValue<string>;
    selectedFerry: ValidatedValue<string>;
    selectedOnlySummary: ValidatedValue<boolean>;
    isSubmitButtonBlocked: boolean;
    isReportGenerated: boolean;
    generatedReport: ListOfShipmentsModel[] | undefined | null;
    generatedReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    currentPage: number;
    summaryCurrentPage: number;
    summaryNumberOfElements: number;
    shipowners: ShipownerModel[];
    ferries: FerryDropDownModel[];
    isSummaryReportGenerated: boolean;
    generatedSummaryReport: ListOfShipmentsSummaryModel[] | undefined | null;
    generatedSummaryReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    ferriesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    shipownersResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class ListOfShipments extends React.Component <any, ListOfShipmentsState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            selectedArrivalFerryFrom: new ValidatedValue(null),
            selectedArrivalFerryTo: new ValidatedValue(null),
            selectedDepartureFerryFrom: new ValidatedValue(null),
            selectedDepartureFerryTo: new ValidatedValue(null),
            selectedRelationType: new ValidatedValue([]),
            selectedCargoType: new ValidatedValue([]),
            selectedOrderStatus: new ValidatedValue([]),
            selectedShipowner: new ValidatedValue(""),
            selectedFerry: new ValidatedValue(""),
            selectedOnlySummary: new ValidatedValue(false),
            shipowners: [],
            ferries: [],
            isSubmitButtonBlocked: false,
            isReportGenerated: false,
            generatedReport: undefined,
            generatedReportResponse: undefined,
            currentPage: 0,
            isSummaryReportGenerated: false,
            generatedSummaryReport: undefined,
            generatedSummaryReportResponse: undefined,
            summaryCurrentPage: 0,
            summaryNumberOfElements: 0,
            ferriesResponse: undefined,
            shipownersResponse: undefined
        };

        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
    }

    async componentDidMount() {
        await this.getFerries();
        await this.getShipowners();
    }

    public render(): JSX.Element {
        const properties = ["relationType", "cargoType", "orderStatus", "bookingNo",
            "ferryName", "shipownerName", "directionType", "voyageNo",
            "arrivalDepartureTime", "actualArrivalDepartureTime", "originDestinationPort",
            "lorryRegNo", "trailerRegNo", "containerNo", "wagonRegNo", "weight"];
        const headers = properties.map(key => i18n.t("reports.listOfShipments.headers." + key));
        const reportSummaryProperties = ["relationType", "cargoType", "orderStatus",
            "numberOfOrders", "weight"];
        const reportSummaryHeaders = reportSummaryProperties.map(key => i18n.t("reports.listOfShipments.headers." + key));
        const isDataLoadedOrDataLoadError = (this.state.shipowners.length > 0 && this.state.ferries.length > 0) ||
            !Api.isSuccess(this.state.shipownersResponse) || !Api.isSuccess(this.state.ferriesResponse);

        if (isDataLoadedOrDataLoadError) {
            return (
                <Report
                    className="list-of-shipments"
                    filters={this.renderFilters()}
                    onGenerateReport={this.onGenerateReport.bind(this)}
                    generatedReport={this.state.generatedReport}
                    generatedReportResponse={this.state.generatedReportResponse}
                    isReportGenerated={this.state.isReportGenerated && !this.state.selectedOnlySummary.value}
                    reportTestId="list-of-shipments"
                    reportProperties={properties}
                    reportHeaders={headers}
                    reportTableRenderCell={this.renderCell}
                    currentPage={this.state.currentPage}
                    reportService={ListOfShipmentsService}
                    isSummaryReportGenerated={this.state.isSummaryReportGenerated}
                    generatedSummaryReport={this.state.generatedSummaryReport}
                    generatedSummaryReportResponse={this.state.generatedSummaryReportResponse}
                    reportSummaryHeaders={reportSummaryHeaders}
                    reportSummaryProperties={reportSummaryProperties}
                    selectedFilters={
                        {
                            arrivalFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryFrom.value),
                            arrivalFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryTo.value),
                            departureFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryFrom.value),
                            departureFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryTo.value),
                            relationType: this.state.selectedRelationType.value,
                            cargoType: this.state.selectedCargoType.value,
                            orderStatus: this.state.selectedOrderStatus.value,
                            shipownerEntityId: this.state.selectedShipowner.value,
                            ferryEntityId: this.state.selectedFerry.value
                        } as ListOfShipmentsFilters
                    }
                    isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                    summaryCurrentPage={this.state.summaryCurrentPage}
                    summaryNumberOfElements={this.state.summaryNumberOfElements}
                />
            );
        } else {
            return <Loader/>;
        }
    }

    private renderCell(row: any, property: string): JSX.Element {
        switch (property) {
            case "relationType":
                return <>{i18n.t(`relationType.${row[property]}`)}</>;
            case "cargoType":
                return <>{i18n.t(`cargoType.${row[property]}`)}</>;
            case "orderStatus":
                return <>{i18n.t(`orderStatus.${row[property]}`)}</>;
            case "directionType":
                return <>{i18n.t(`directionType.${row[property]}`)}</>;
            case "arrivalDepartureTime":
            case "actualArrivalDepartureTime":
                return <>{DateUtils.getFormattedDateWithTime((row[property]))}</>;
            default:
                return row[property];
        }
    }

    private renderFilters(): JSX.Element {
        return (
            <>
                <DateTimePicker
                    label={i18n.t("reports.listOfShipments.filters.arrivalFerryFrom")}
                    validatedValue={this.state.selectedArrivalFerryFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedArrivalFerryFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedArrivalFerryFrom, this.state.selectedArrivalFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-arrival-ferry-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.listOfShipments.filters.arrivalFerryTo")}
                    validatedValue={this.state.selectedArrivalFerryTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedArrivalFerryTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedArrivalFerryFrom, this.state.selectedArrivalFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-arrival-ferry-to"
                />
                <DateTimePicker
                    label={i18n.t("reports.listOfShipments.filters.departureFerryFrom")}
                    validatedValue={this.state.selectedDepartureFerryFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepartureFerryFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepartureFerryFrom, this.state.selectedDepartureFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-departure-ferry-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.listOfShipments.filters.departureFerryTo")}
                    validatedValue={this.state.selectedDepartureFerryTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepartureFerryTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepartureFerryFrom, this.state.selectedDepartureFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-departure-ferry-to"
                />
                <MultiSelectDropDown
                    label={i18n.t("reports.listOfShipments.filters.relationType")}
                    items={RelationTypeDropdownItems.getRelationTypes()}
                    validatedValue={this.state.selectedRelationType}
                    testId="filters-relation-type"
                />
                <MultiSelectDropDown
                    label={i18n.t("reports.listOfShipments.filters.cargoType")}
                    items={CargoTypeDropdownItems.getCargoTypeDropdownItems()}
                    validatedValue={this.state.selectedCargoType}
                    testId="filters-cargo-type"
                />
                <MultiSelectDropDown
                    label={i18n.t("reports.listOfShipments.filters.orderStatus")}
                    items={OrderStatusDropdownItems.getOrderStatusDropdownItems()}
                    validatedValue={this.state.selectedOrderStatus}
                    testId="filters-order-status"
                />
                <DropDown
                    label={i18n.t("reports.listOfShipments.filters.shipowner")}
                    items={this.shipownerToDropDownMap}
                    validatedValue={this.state.selectedShipowner}
                    testId="filters-shipowner"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.shipownersResponse) ? i18n.t("errorMessages.shipownersErrorSuffix") : ""}
                    reloadFunc={() => this.getShipowners()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.listOfShipments.filters.ferry")}
                    items={this.ferryToDropDownMap}
                    validatedValue={this.state.selectedFerry}
                    testId="filters-ferry"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.ferriesResponse) ? i18n.t("errorMessages.ferriesErrorSuffix") : ""}
                    reloadFunc={() => this.getFerries()}
                    isNoRequired
                />
                <Checkbox
                    label={i18n.t("reports.listOfShipments.filters.onlySummary")}
                    size="medium"
                    validatedValue={this.state.selectedOnlySummary}
                    testId="filters-only-summary"
                />
            </>
        );
    }

    private get shipownerToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.shipowners, "entityId");
    }

    private get ferryToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.ferries, "entityId");
    }

    private get isValid(): boolean {
        this.state.selectedArrivalFerryFrom.validate();
        this.state.selectedArrivalFerryTo.validate();
        this.state.selectedDepartureFerryFrom.validate();
        this.state.selectedDepartureFerryTo.validate();
        this.state.selectedFerry.validate();
        this.state.selectedShipowner.validate();
        this.state.selectedRelationType.validate();
        this.state.selectedCargoType.validate();
        this.state.selectedOrderStatus.validate();
        this.state.selectedOnlySummary.validate();

        return this.state.selectedArrivalFerryFrom.isValid && this.state.selectedArrivalFerryTo.isValid
        && this.state.selectedDepartureFerryFrom.isValid && this.state.selectedDepartureFerryTo.isValid
        && this.state.selectedFerry.isValid && this.state.selectedShipowner.isValid
        && this.state.selectedRelationType.isValid && this.state.selectedCargoType.isValid
        && this.state.selectedOrderStatus.isValid && this.state.selectedOnlySummary.isValid;
    }

    private async onGenerateReport() {
        this.setState({generatedReportResponse: undefined});
        const paginationStore = this.context.paginationStore as IPaginationStore;

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});

            const filters = {
                arrivalFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryFrom.value),
                arrivalFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryTo.value),
                departureFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryFrom.value),
                departureFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryTo.value),
                relationType: this.state.selectedRelationType.value,
                cargoType: this.state.selectedCargoType.value,
                orderStatus: this.state.selectedOrderStatus.value,
                shipownerEntityId: this.state.selectedShipowner.value,
                ferryEntityId: this.state.selectedFerry.value
            };

            if (this.state.selectedOnlySummary.value) {
                await this.generatedSummaryReport(filters);
            } else {
                const generatedReportResponse = await ListOfShipmentsService.generateReport(
                    filters
                );

                this.setState({
                    generatedReportResponse,
                    generatedReport: generatedReportResponse?.data?.data || null,
                    isReportGenerated: true,
                    currentPage: generatedReportResponse?.data?.currentPage
                });

                if (Api.isSuccess(generatedReportResponse)) {
                    await this.generatedSummaryReport(filters);
                }

                paginationStore.setNumberOfElements(generatedReportResponse?.data?.numberOfElements);
                paginationStore.setNumberOfPages(generatedReportResponse?.data?.numberOfPages);
            }
        }

        Utils.scrollToFirstErrorMessage();
        this.setState({isSubmitButtonBlocked: false});
    }

    private async generatedSummaryReport(filters: ListOfShipmentsFilters) {
        const generatedSummaryReportResponse = await ListOfShipmentsService.generateSummaryReport(
            filters
        );

        this.setState({
            generatedSummaryReportResponse,
            generatedSummaryReport: generatedSummaryReportResponse?.data?.data || null,
            isSummaryReportGenerated: true,
            isSubmitButtonBlocked: false,
            summaryCurrentPage: generatedSummaryReportResponse?.data?.currentPage,
            summaryNumberOfElements: await generatedSummaryReportResponse?.data?.numberOfElements
        });
    }

    private async getShipowners() {
        const shipownersResponse = await ShipownerService.getAll();

        this.setState({
            shipowners: (shipownersResponse)?.data?.data || [],
            shipownersResponse
        });
    }

    private async getFerries() {
        const ferriesResponse = await FerryService.getFerriesForDropDown();

        this.setState({
            ferries: (ferriesResponse)?.data || [],
            ferriesResponse,
        });
    }
}
